module.exports = __webpack_public_path__ + "media/images/gray-facebook-1253823f1650c0bd03a14d34880234a1.png";